import { useState } from "react";
import NavigationTabs from "../../../../utils/components/NavigationTabs";
import Modal from "../../../../utils/components/Modal";
import StepWorkers from "./components/StepWorkers";
import StepResults from "./components/StepResults";
import StepInfo from "./components/StepInfo";
import StepStatus from "./components/StepStatus";

const StepEdit = ({
  translate,
  isModalOpen,
  onModalClose,
  handlePositiveButtonClick,
  stepData,
  stepsList,
  users,
  statusSets,
  workflowType,
}) => {
  const [step, setStep] = useState(stepData);
  const [activeTab, setActiveTab] = useState(
    translate("design_approval_process.step-edit-modal.step-workers")
  );

  const handleAction = (type, data) => {
    switch (type) {
      case "step_workers":
        handleStepWorkers(data);
        break;
      case "step_results":
        handleStepResults(data);
        break;
      case "step_info":
        handleStepInfo(data);
        break;
      case "step_status":
        handleStepStatus(data);
        break;
      default:
        break;
    }
  };

  const handleStepWorkers = (stepWorkers) => {
    let selectedWorkers = [];
    stepWorkers.selectedPersons.forEach((person) => {
      selectedWorkers.push(person.id);
    });

    setStep({
      ...step,
      settings: {
        ...step.settings,
        step_workers: {
          ...step.settings.step_workers,
          users: selectedWorkers,
          can_be_delegated: stepWorkers.canBeDelegated,
          set_workers_on_task_start: stepWorkers.setWorkersOnTaskStart,
        },
      },
    });
  };

  const handleStepResults = (stepResults) => {
    setStep({
      ...step,
      settings: {
        ...step.settings,
        results: stepResults,
      },
    });
  };

  const handleStepInfo = (stepInfo) => {
    let selectedPersons = [];
    stepInfo.personsToBeInformed.forEach((person) => {
      selectedPersons.push(person.id);
    });
    setStep({
      ...step,
      settings: {
        ...step.settings,
        step_info: {
          info_users: selectedPersons,
          info_title: stepInfo.textTitle,
          info_description: stepInfo.textContent,
        },
      },
    });
  };

  const handleStepStatus = (stepStatus) => {
    let selectedStatuses = [];
    Object.keys(stepStatus).forEach((status) => {
      if (stepStatus[status]) selectedStatuses.push(stepStatus[status]);
    });
    setStep({
      ...step,
      settings: {
        ...step.settings,
        step_statuses: selectedStatuses,
      },
    });
  };

  return (
    <div>
      <Modal
        title={translate("design_approval_process.step-edit-modal.step-edit", {
          stepName: stepData?.name,
        })}
        positiveButtonNode={translate("save")}
        negativeButtonNode={translate("cancel")}
        positiveButtonHandler={() =>
          handlePositiveButtonClick({ ...step, workflowType })
        }
        negativeButtonHandler={() => onModalClose()}
        modalSize="xl"
        show={isModalOpen}
        setShow={() => onModalClose()}
      >
        <div className="border-bottom mb-4">
          <NavigationTabs
            tabs={[
              translate("design_approval_process.step-edit-modal.step-workers"),
              translate("design_approval_process.step-edit-modal.step-results"),
              translate("design_approval_process.step-edit-modal.step-info"),
              translate("design_approval_process.step-edit-modal.step-status"),
            ]}
            activeTab={activeTab}
            onTabClick={(tab) => setActiveTab(tab)}
          />
        </div>
        <div className="ms-3">
          <div className="inner-page mb-5">
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-workers"
              ) && (
              <StepWorkers
                step={step}
                users={users}
                handleAction={handleAction}
                translate={translate}
                workflowType={workflowType}
              />
            )}
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-results"
              ) && (
              <StepResults
                step={step}
                stepsList={stepsList}
                handleAction={handleAction}
                translate={translate}
                workflowType={workflowType}
              />
            )}
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-info"
              ) && (
              <StepInfo
                step={step}
                users={users}
                handleAction={handleAction}
                translate={translate}
              />
            )}
            {activeTab ===
              translate(
                "design_approval_process.step-edit-modal.step-status"
              ) && (
              <StepStatus
                step={step}
                stepsList={stepsList}
                handleAction={handleAction}
                translate={translate}
                statusSets={statusSets}
                workflowType={workflowType}
              />
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default StepEdit;
